enum ENVIRONMENT {
	LOCALHOST,
	STAGING,
	UAT,
	PRODUCTION,
}

export default ENVIRONMENT;
